module.exports = __webpack_public_path__ + "img/cloudPurchase_pattern.532e3d90.png";